"use client" 

// invoked from src/app/admin/jobs/page.js
// invoked from src/app/admin/layout.js
import { useEffect, useState, useRef } from "react";
import axios from "axios";

import { humanizeString } from "@/utils/frontend/stringOps.js";
import ModalOverlay from "../../Atoms/ModalOverlay.js";
import ModalHeader from "./ModalHeader.js";
import ModalFooter from "./ModalFooter.js";
import RadioButton from "../../Atoms/Buttons/RadioButton.js";
import FormSubHeading from "../../Atoms/FormElements/FormSubHeading.js";
import RadioButton_1 from "../../Atoms/Buttons/RadioButton_1.js";
import LocationSelect from "../../Atoms/Select/LocationSelect.js";
import { getCookies } from "@/utils/frontend/cookieOps.js";
import InputText from "@/components/Atoms/inputText.js";
import TextEditor from "../TextEditor.js";
import TagsAssociationSelect from "@/components/Atoms/Select/TagsAssociationSelect.js";
import DatePicker from "@/components/Atoms/FormElements/DatePicker.js";
import SectorSelect from "@/components/Atoms/Select/SectorSelect.js";
import OrganizationSelect from "@/components/Atoms/Select/OrganizationSelect.js";
import validateRequiredFields from "@/utils/frontend/validateRequiredFields.js";
import { validateRequiredFieldsManually } from "@/utils/frontend/validateRequiredFieldsManually.js";
import MarkdownEditor from "../MarkdownEditor.js";
import JobPreviewCard from "../Cards/JobPreviewCard.js";
import ReactMarkdownMod from "@/components/Atoms/ReactMarkdownMod.js";
import DivisionSelect from "@/components/Atoms/Select/DivisionSelect.js";
import ReactMarkdownMod_2 from "@/components/Atoms/ReactMarkdownMod_2.js";
import LocationSelectGeoNames from "@/components/Atoms/Select/LocationSelectGeoNames.js";
import { useRouter } from "next/navigation.js";
import InquiryForm from "../Forms/InquiryForm.js";



const InquiryModal =  ({
  lang,
  state,
  callback,
  target,
  organizationPreferences,
  modalHeaderCaption,
  user,
  requestType,
}) => {

  const router = useRouter()
  // console.log("TARGET@JOBMODAL", target)

  const textAreaRef1 = useRef(null);
  const textAreaRef2 = useRef(null);

  // const user = getCookies().user


// get current Primary and Secondary tag associations and set them as default values for 
let targetAssociatedLevel1Tags = [] // later set as State
let targetAssociatedLevel2Tags = [] // later set as State
let targetAssociatedLevel3Tags = [] // later set as State
if (target && target.tags) { 
  target.tags.filter(tag => {tag.tag_snapshot.tag_level === 1 ? targetAssociatedLevel1Tags.push(tag) : tag.tag_snapshot.tag_level === 2 ? targetAssociatedLevel2Tags.push(tag) : targetAssociatedLevel3Tags.push(tag)})
}

let missingFieldsInit = {
  job_title_en: false,
  job_description_en: false,
  job_title_fr: false,
  job_description_fr: false,
  job_salary: false,
  job_location: false,
  // job_location_country: false,
  // job_location_state: false,
  // job_location_city: false,
  job_employer_sector_industry: false,
  job_sector_industry: false
}


const [loading, setLoading] = useState(false)
const [data, setData] = useState() 
const [selectedTags, setSelectedTags] = useState()
const [selectedLevel1Tags, setSelectedLevel1Tags] = useState(targetAssociatedLevel1Tags)
const [selectedLevel2Tags, setSelectedLevel2Tags] = useState(targetAssociatedLevel2Tags)
const [selectedLevel3Tags, setSelectedLevel3Tags] = useState(targetAssociatedLevel3Tags)
const [tagsTable, setTagsTable] = useState(null)
const [missingFields, setMissingFields] = useState(missingFieldsInit)
const [previewOpen, setPreviewOpen] = useState(true)
const [fieldInFocus, setFieldInFocus] = useState(null)
const [langInFocus, setLangInFocus] = useState('en')







  


  const handleClose = async () => {
    state.setJobModalOpen(false)
    callback({resetTarget: true})
  }



  // const handleChange = (event) => {
  //   setData({
  //     ...data,
  //     [event.target?.name]: event.target?.value,
  //   });
  //   console.log(data);
  // };

 



  return (
    <>

{/* <div class="right-0 top-0 overflow-x-hidden overflow-y-auto fixed inset-0 z-40 outline-none focus:outline-none mt-0 duration-300 ease-in-out transition-transform transform translate-x-full"> */}
<div
  className={`right-0 top-0 opacity-100 overflow-x-hidden overflow-y-hidden fixed inset-0 z-40 outline-none focus:outline-none mt-0 duration-300 ease-in-out transition-transform transform ${
    state.talentInquiryModal === true ? 'translate-x-0' : 'translate-x-full'
  }`}
>

   <div className="border-0 min-h-screen shadow-none relative flex flex-col w-full bg-white outline-none focus:outline-none dark:bg-gray-900">
                  {/*header*/}
                  {/* <div className="flex items-start z-40 justify-between p-5 border-b border-solid border-slate-200 rounded-t"> */}

                  <ModalHeader caption={modalHeaderCaption} closeOnClickMethod={() => {router.push('?')}}/>
<div className="flex justify-center items-center h-[85vh]">
<div className="w-full lg:w-1/3">
     <InquiryForm
    //  callback={(cb)=>{return cb === 'closeModal' && callback('closeModal')}}
     fieldCompanyName={requestType === 'introduction'} // if introduction, show field, if question, don't
     fieldEmailAddress={true}
     fieldMessage={true}
     fieldMessagePresetValue={`Hello ${target.talent_user_data?.user_first_name}, when is ${target.talent_pseudonym} available to interview?`}
     requestType={requestType}
     recordUUID={target.talent_uuid}
     recordType={'TALENT'}
      notifyUserUUID={target.talent_user_uuid}
              darkBGValue={'dark:bg-slate-900'}
              lang={lang} 
            parentComponent={'TALENT'} 
            parentPath={'talentUrlOrUserHandle'}
            buttonCaption={`Meet ${target.talent_pseudonym}`}
            //  placeholderColor={}
     />
     </div>
     </div>
                    </div>

<div className="lg:mb-0 px-4 w-full h-screen lg:sticky top-0 overflow-auto no-scrollbar lg:flex flex-col justify-center" key={target?.id}>

            
            </div>




          </div>

          {state.jobModalOpen && <ModalOverlay/>}
        </>

  );
};

export default InquiryModal;


















